// pages/LiveEvent.js — Live Event Coverage (curated archive by year)
import { useState, useEffect, useRef, useCallback } from "react";
import TopBar from "../components/TopBar";
import Header from "../components/Header";
import PreFooter from "../components/PreFooter";
import Footer from "../components/Footer";

const NEW_BADGE_DAYS = 30;

function extractYouTubeId(url) {
  const match = url.match(
    /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|live\/|embed\/|shorts\/))([A-Za-z0-9_-]{11})/
  );
  return match ? match[1] : null;
}

/* ─── Archive (fallback + history). Live videos are prepended automatically. ─── */
const videoData = [
  {
    year: "2026",
    videos: [
      { id: "8RBa9A3BM8w", title: "New Year Celebration – 2026" },
      { id: "ohrHe_bAEuo", title: "Welcome Ceremony of the New Intake 2025/26 – Faculty of Management" },
      { id: extractYouTubeId("https://www.youtube.com/live/rZwsExelpYM"), title: "Inauguration Ceremony – Batch 2024/25, Faculty of Allied Health Sciences" },
      { id: extractYouTubeId("https://www.youtube.com/live/HqhoRD3MkD8"), title: "New Entrants Welcome – Faculty of Veterinary and Animal Sciences 2024/2025" },
      { id: extractYouTubeId("https://www.youtube.com/watch?v=iy5jraDWZHQ"), title: "General Convocation – 2025 (Session I)" },
      { id: extractYouTubeId("https://www.youtube.com/watch?v=Swx6btP5pPI"), title: "General Convocation – 2025 (Session II)" },
      { id: extractYouTubeId("https://www.youtube.com/watch?v=-f8Yw8cxxYU"), title: "87th General Convocation – 2025 (Session III)" },
      { id: extractYouTubeId("https://www.youtube.com/watch?v=xhSgelmeDm4"), title: "87th General Convocation – 2025 (Session IV)" },
      { id: extractYouTubeId("https://www.youtube.com/watch?v=YNahHAelNcw"), title: "Founder's Day & Alumni Excellence Awards – 2026" },
      { id: extractYouTubeId("https://www.youtube.com/watch?v=UvVCRV_cPnw"), title: "Student Welcome Ceremony – 2025/26" },
      { id: extractYouTubeId("https://www.youtube.com/watch?v=P0WU5uIgmc4"), title: "iPURSE 2026" },
      { id: extractYouTubeId("https://www.youtube.com/watch?v=fJYakAIi-8o"), title: "Future Life – International Buddhist Conference 2026" },
      { id: extractYouTubeId("https://www.youtube.com/watch?v=ALfYtT6G5wE"), title: "Back to Faculty – Faculty of Dental Sciences | UOP" },
      { id: extractYouTubeId("https://www.youtube.com/watch?v=1ucYlJI5WJU"), title: "Nursing Pledge Ceremony of Batch 2023/24" },
      { id: extractYouTubeId("https://www.youtube.com/watch?v=D1nAIn2LFAg"), title: "Welcome Ceremony of New Entrants 2025/26 – Faculty of Dental Sciences" },
    ],
  },
  {
    year: "2025",
    videos: [
      { id: "0fAmFPSl_jc", title: "Founder's Day and Alumni Excellence Awards Ceremony 2025" },
      { id: "q7S7U-0sCPc", title: "National Archaeological Symposium – 2025" },
      { id: "MuDUdO4EXoI", title: "Welcome Ceremony for New Entrants 2024/25 – Faculty of Arts" },
      { id: "RSCndtx3dPc", title: '"Puducherry" World History Congress – PWHC 2025' },
      { id: "5qFULxuTzq0", title: "iPURSE 2025" },
      { id: extractYouTubeId("https://www.youtube.com/live/PtGsKSQXgWw"), title: "Welcome Ceremony – Batch 2023/2024, Faculty of Veterinary Medicine and Animal Science" },
      { id: extractYouTubeId("https://www.youtube.com/live/PcVEjhHXhlM"), title: "Nursing Pledge Ceremony of Batch 2022/2023" },
      { id: extractYouTubeId("https://www.youtube.com/live/C4OoncX88J0"), title: "Welcome Ceremony of New Entrants – 2024/2025" },
      { id: extractYouTubeId("https://www.youtube.com/live/S_ObEijsl3w"), title: "International Conference on English Language Teaching 2025" },
      { id: extractYouTubeId("https://www.youtube.com/live/R1kMQmG3mTM"), title: "Welcome Ceremony for New Entrants – Faculty of Engineering" },
      { id: extractYouTubeId("https://www.youtube.com/live/gepQVlfx-v0"), title: "Undergraduate Research Congress of the Faculty of Arts (URCFA 2025)" },
      { id: extractYouTubeId("https://www.youtube.com/live/rn0K_OVfGZU"), title: "86th General Convocation, Day 01 / Session 01, University of Peradeniya" },
      { id: extractYouTubeId("https://www.youtube.com/live/FR3roId1dUA"), title: "86th General Convocation, Day 01 / Session II, University of Peradeniya" },
      { id: extractYouTubeId("https://www.youtube.com/live/OY4C3s_KDx8"), title: "86th General Convocation, Day 02 / Session III, University of Peradeniya" },
      { id: extractYouTubeId("https://www.youtube.com/live/a0x-p13P4BM"), title: "86th General Convocation, Day 02 / Session IV, University of Peradeniya" },
      { id: extractYouTubeId("https://www.youtube.com/live/ikGEJH39eBI"), title: "Inaugural Session of the New Entrants – 2023/24, Faculty of Agriculture" },
      { id: extractYouTubeId("https://www.youtube.com/live/cLavISumc04"), title: "Inaugural Ceremony 2023/2024, Faculty of Allied Health Sciences" },
      { id: extractYouTubeId("https://www.youtube.com/live/L_0ZDcl6TrA"), title: "Staff Excellence Awards 2024" },
      { id: extractYouTubeId("https://www.youtube.com/live/HFqweX14rFg"), title: "Welcome Ceremony of the New Intake – 2025" },
      { id: extractYouTubeId("https://www.youtube.com/live/S68gRmkv88I"), title: "Colours Awards Ceremony 2024" },
    ],
  },
  {
    year: "2024",
    videos: [
      { id: "O4Agl8nckPw", title: "iPURSE 2024" },
      { id: extractYouTubeId("https://www.youtube.com/live/ecmlGqEILIM"), title: "Undergraduate Research Congress – Faculty of Arts (URCFA-2024)" },
      { id: extractYouTubeId("https://www.youtube.com/live/6mthi_85pxk"), title: "Nursing Pledge Ceremony – Batch 2021/22" },
      { id: extractYouTubeId("https://www.youtube.com/live/5FfeLIP-vPY"), title: "Welcome Ceremony – Batch 2022/2023, Faculty of Veterinary Medicine and Animal Science" },
      { id: extractYouTubeId("https://www.youtube.com/live/ptylJQRi7Uc"), title: "Inauguration Ceremony – 2023 Intake, Faculty of Engineering" },
      { id: extractYouTubeId("https://www.youtube.com/live/mDZw_F9Gpuw"), title: "Welcome of New Entrants 2022/23 – Faculty of Allied Health Sciences" },
      { id: extractYouTubeId("https://www.youtube.com/live/N-XjvGvQcqU"), title: "Welcome of New Entrants 2023/24 – Faculty of Arts" },
      { id: extractYouTubeId("https://www.youtube.com/live/X8WkWqIC22I"), title: "85th General Convocation – 2023 – Session IV (22nd Aug. 2024, Evening)" },
      { id: extractYouTubeId("https://www.youtube.com/live/eyF5Y7f6e1c"), title: "85th General Convocation – 2023 – Session III (22nd Aug. 2024 Morning)" },
      { id: extractYouTubeId("https://www.youtube.com/live/fGo2fbFz6TE"), title: "85th General Convocation – 2023 – Session II (Evening)" },
      { id: extractYouTubeId("https://www.youtube.com/live/54xY_NV78iA"), title: "85th General Convocation – 2023 – Session I" },
      { id: extractYouTubeId("https://www.youtube.com/live/gS_RT4m0LG0"), title: '"පරිසර තතු පැන පිළිතුරු" – සහතික පිරිනැමීමේ උත්සවය' },
      { id: extractYouTubeId("https://www.youtube.com/live/4yGnlHRpKR4"), title: '"පරිසර තතු පැන පිළිතුරු" – අන්තර් පාඨශාලයීය තරඟාවලිය' },
      { id: extractYouTubeId("https://www.youtube.com/live/SRON1pzRk8M"), title: '"පරිසර තතු පැන පිළිතුරු" – අවසන් තරඟය' },
      { id: extractYouTubeId("https://www.youtube.com/live/Jxphm8CCafs"), title: "Induction Ceremony of the New Vice-Chancellor" },
      { id: extractYouTubeId("https://www.youtube.com/live/j4X0V8zpzM8"), title: "Welcome Ceremony for New Entrants – Batch E 22" },
      { id: extractYouTubeId("https://www.youtube.com/live/caK5k_GOccg"), title: "Welcome Ceremony – 2023/24, Faculty of Management, University of Peradeniya" },
      { id: extractYouTubeId("https://www.youtube.com/live/FsM2rAaFpCI"), title: "Commencement of the New Year – 2024" },
    ],
  },
  {
    year: "2023",
    videos: [
      { id: "36bHyZE_TA0", title: "Technical Talk Series – Episode 01, CES, University of Peradeniya" },
      { id: "LGB82IRPArs", title: "Three-Minute Presentation Session and the Certificate Awarding Ceremony" },
      { id: extractYouTubeId("https://www.youtube.com/live/55fJ1HcE95w"), title: "Nursing Pledge Ceremony of Batch 2020/2021 – Department of Nursing, Faculty of Allied Health Sciences" },
      { id: extractYouTubeId("https://www.youtube.com/live/iYQVfRdnWdU"), title: "International Week 2023, University of Peradeniya" },
      { id: extractYouTubeId("https://www.youtube.com/live/i2x5vcE8fcQ"), title: "Inauguration of the Faculty of Science 2021 Batch" },
      { id: extractYouTubeId("https://www.youtube.com/live/ZQZyijJA8TQ"), title: "Peradeniya University International Research Sessions (iPURSE) 2023" },
      { id: extractYouTubeId("https://www.youtube.com/live/6HZuo6iffw4"), title: "ICCES 2023 – Third International Conference of the Centre for Environmental Sustainability" },
      { id: extractYouTubeId("https://www.youtube.com/live/2vHvPdC87tE"), title: "New Entrants Welcome 2021–2022, Faculty of Veterinary Medicine & Animal Science" },
      { id: extractYouTubeId("https://www.youtube.com/live/AlOOf--BJFA"), title: "Founder's Day Celebration, University of Peradeniya, Sri Lanka" },
      { id: extractYouTubeId("https://www.youtube.com/live/9Q7F1iw1Iow"), title: "Inauguration Ceremony, 2021–2022 Batch, Faculty of Engineering" },
      { id: extractYouTubeId("https://www.youtube.com/live/62MIYg_eQYU"), title: "84th General Convocation 2022 – Day 2 Session I" },
      { id: extractYouTubeId("https://www.youtube.com/live/2Rg_1dK8ovo"), title: "84th General Convocation 2022 – Day 1 Session II" },
      { id: extractYouTubeId("https://www.youtube.com/live/fz6-97_rZKo"), title: "84th General Convocation 2022 – Day 1 Session I" },
      { id: extractYouTubeId("https://www.youtube.com/live/vXaAvOxVtew"), title: "New Entrants Welcome 2020/2021" },
      { id: extractYouTubeId("https://www.youtube.com/live/SdigodMGQkk"), title: "Commencement of the New Year 2023, University of Peradeniya" },
    ],
  },
  {
    year: "2022",
    videos: [
      { id: "oUePfcIKv9c", title: "Introduction to the Faculty of Arts" },
      { id: "eF9eFpJ5Gxc", title: "Faculty of Science" },
      { id: extractYouTubeId("https://www.youtube.com/live/9HYpZjeUlEE"), title: "International Week 2022" },
      { id: extractYouTubeId("https://www.youtube.com/live/9piNG5EMCaY"), title: "Diamond Jubilee Celebrations – University of Peradeniya" },
    ],
  },
  {
    year: "2017",
    videos: [
      { id: "AYUBWQVBRZA", title: "75th Anniversary of University of Peradeniya – Sirasa TV, 1st February" },
      { id: "e8yg53Can8I", title: "Sarasavi Mathra 2017 – Acoustic Music Band, University of Peradeniya (Part 1)" },
      { id: "ImqMF1UjpjY", title: "Sarasavi Mathra 2017 – Acoustic Music Band, University of Peradeniya (Part 2)" },
      { id: "xrWi6gEqNy4", title: "Message from Sir Ivor Jennings' Granddaughter" },
    ],
  },
  {
    year: "2016",
    videos: [
      { id: "gogw9zcvigw", title: "SLT Wi-Fi Launched at University of Peradeniya" },
      { id: "DPo1F5ZlRws", title: "Gammedda's Final Report Handed Over to UN at World Humanitarian Summit" },
    ],
  },
  {
    year: "2015",
    videos: [
      { id: "raZTRX3P770", title: "Vts 01 – Part 1" },
      { id: "RYwIMWb2SJA", title: "Vts 01 – Part 2" },
      { id: "4KyZPMmZfTI", title: "Vts 01 – Part 3" },
      { id: "yPER8OfcHEY", title: "Vts 01 – Part 4" },
    ],
  },
  {
    year: "2014",
    videos: [
      { id: "oyJ1RutEXs0", title: "2014 Conversation – Video 1", unnamed: true },
      { id: "FqcPQYiwkuA", title: "2014 Conversation – Video 2", unnamed: true },
      { id: "_FWzasTafdE", title: "2014 Conversation – Video 3", unnamed: true },
      { id: "zgiC8w4bdps", title: "2014 Conversation – Video 4", unnamed: true },
      { id: "41hfi34cPng", title: "2014 Conversation – Video 5", unnamed: true },
      { id: "ied0WVSCw-U", title: "2014 Conversation – Video 6", unnamed: true },
      { id: "tfHKKLeoAGs", title: "2014 Conversation – Video 7", unnamed: true },
      { id: "2nX3JVlP7MY", title: "2014 Conversation – Video 8", unnamed: true },
      { id: "gKGSwqNNsMY", title: "Japan Sri Lanka" },
      { id: "aXmTN8VmIcA", title: "SLJCR-2014" },
    ],
  },
].map((yr) => ({
  ...yr,
  videos: yr.videos.filter((v) => v.id), // drop any failed extracts
  count: yr.videos.filter((v) => v.id).length,
}));

/* ─── Live-feed helpers ─── */

function isFresh(published) {
  if (!published) return false;
  const diff = Date.now() - new Date(published).getTime();
  return diff >= 0 && diff < NEW_BADGE_DAYS * 24 * 60 * 60 * 1000;
}

function formatDate(published) {
  if (!published) return "";
  try {
    return new Date(published).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } catch {
    return "";
  }
}

const ALL_YEARS = ["all", ...videoData.map((d) => d.year)];
const TOTAL_VIDEOS = videoData.reduce((sum, yr) => sum + yr.videos.length, 0);
const TOTAL_YEARS = videoData.length;
const EARLIEST_YEAR = videoData[videoData.length - 1].year;

function VideoCard({ video, year }) {
  const [active, setActive] = useState(false);
  const thumbUrl = video.thumbnail || `https://i.ytimg.com/vi/${video.id}/mqdefault.jpg`;
  const fresh = isFresh(video.published);

  return (
    <div className="video-card">
      <div
        className="thumb-wrap"
        onClick={() => setActive(true)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === "Enter" && setActive(true)}
        aria-label={`Play ${video.title}`}
      >
        {active ? (
          <iframe
            src={`https://www.youtube.com/embed/${video.id}?autoplay=1`}
            title={video.title}
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        ) : (
          <>
            <img src={thumbUrl} alt={video.title} loading="lazy" decoding="async" />
            <div className="play-overlay">
              <div className="play-btn-icon">▶</div>
            </div>
            {fresh && <span style={newBadgeStyle}>NEW</span>}
          </>
        )}
      </div>
      <div className="card-info">
        <div className={`card-title${video.unnamed ? " unnamed" : ""}`}>{video.title}</div>
        <span className="card-year-tag">{year}</span>
        {video.published && (
          <span className="card-year-tag" style={{ marginLeft: 6, background: "#f0f0f0" }}>
            {formatDate(video.published)}
          </span>
        )}
      </div>
    </div>
  );
}

function YearBlock({ yearData, visible }) {
  const blockRef = useRef(null);

  useEffect(() => {
    const el = blockRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      className="year-block"
      data-year={yearData.year}
      ref={blockRef}
      style={{ display: visible ? "" : "none" }}
    >
      <div className="year-heading">
        <div className="year-label">{yearData.year}</div>
        <div className="year-divider" />
        <div className="year-count">
          {yearData.count} video{yearData.count !== 1 ? "s" : ""}
        </div>
      </div>
      <div className="video-grid">
        {yearData.videos.map((video) => (
          <VideoCard key={video.id} video={video} year={yearData.year} />
        ))}
      </div>
    </div>
  );
}

function LiveEvent() {
  const [activeYear, setActiveYear] = useState("all");
  const [staffVideos, setStaffVideos] = useState([]);

  // Staff-added videos (via admin panel) — silent fallback to archive-only if unreachable
  useEffect(() => {
    let cancelled = false;
    const urls = [
      "/backend/videos_list.php",
      "http://localhost/reactwebmedia/backend/videos_list.php",
    ];
    (async () => {
      for (const u of urls) {
        try {
          const res = await fetch(u);
          if (!res.ok) continue;
          const data = await res.json();
          if (data && data.success && Array.isArray(data.videos) && data.videos.length) {
            if (!cancelled) {
              setStaffVideos(
                data.videos.map((v) => ({
                  id: v.youtube_id,
                  title: v.title,
                  published: v.created_at,
                  year: v.year,
                  thumbnail: `https://i.ytimg.com/vi/${v.youtube_id}/mqdefault.jpg`,
                }))
              );
            }
            return;
          }
        } catch {
          // try next URL
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleYearClick = useCallback((year) => {
    setActiveYear(year);
    if (year !== "all") {
      setTimeout(() => {
        const block = document.querySelector(`.year-block[data-year="${year}"]`);
        if (block) block.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 50);
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  return (
    <>
      <TopBar />
      <Header activePage="liveevent" />

      {/* ── Page Hero with background photo ── */}
      <section className="page-hero liveevent-hero" style={heroSectionStyle}>

        {/* Background photo */}
        <div style={heroBgStyle}></div>

        {/* Dark maroon gradient overlay */}
        <div style={heroOverlayStyle}></div>

        {/* Gold dashed top border — kept from original */}
        <div style={heroTopBorderStyle}></div>

        {/* All hero content sits above the overlay */}
        <div style={heroContentStyle}>
          <div className="hero-badge">&#9654; Video Archive</div>
          <h2 style={heroH2Style}>Live Event Coverage</h2>
          <p style={heroParaStyle}>
            A curated collection of events, ceremonies, and programmes captured by
            the Media &amp; Community Relations Centre
          </p>
          <div className="hero-stats">
            <div className="stat">
              <span className="stat-num">{TOTAL_VIDEOS + staffVideos.length}</span>
              <span className="stat-label">Videos</span>
            </div>
            <div className="stat">
              <span className="stat-num">{TOTAL_YEARS}</span>
              <span className="stat-label">Years</span>
            </div>
            <div className="stat">
              <span className="stat-num">{EARLIEST_YEAR}</span>
              <span className="stat-label">Since</span>
            </div>
          </div>
        </div>
      </section>

      {/* Archive Section */}
      <section className="archive-section">
        <div className="archive-content">

          {/* ── Staff-added latest videos (via admin panel) ── */}
          {staffVideos.length > 0 && (
            <div style={latestBoxStyle}>
              <div className="year-heading">
                <div className="year-label" style={{ fontSize: "clamp(22px, 3vw, 30px)" }}>
                  ✨ Latest Updates
                </div>
                <div className="year-divider" />
                <div className="year-count">
                  {staffVideos.length} new video{staffVideos.length !== 1 ? "s" : ""}
                </div>
              </div>
              <div className="video-grid">
                {(activeYear === "all"
                  ? staffVideos
                  : staffVideos.filter((v) => v.year === activeYear)
                ).map((video) => (
                  <VideoCard key={`staff-${video.id}`} video={video} year={video.year} />
                ))}
              </div>
            </div>
          )}

          <div className="year-nav">
            {ALL_YEARS.map((year) => (
              <button
                key={year}
                className={`year-btn${activeYear === year ? " active" : ""}`}
                onClick={() => handleYearClick(year)}
              >
                {year === "all" ? "All Years" : year}
              </button>
            ))}
          </div>

          <div style={archiveLabelStyle}>📚 Archive by year</div>

          {videoData.map((yearData) => (
            <YearBlock
              key={yearData.year}
              yearData={yearData}
              visible={activeYear === "all" || activeYear === yearData.year}
            />
          ))}
        </div>
      </section>

      <PreFooter />
      <Footer />
    </>
  );
}

export default LiveEvent;

/* ─── Hero inline styles ─── */

/* Override .liveevent-hero display:block — we need flex for centering */
const heroSectionStyle = {
  position: "relative",
  display: "flex !important",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "420px",
  height: "auto",
  padding: "0",
};

/* Background photo */
const heroBgStyle = {
  position: "absolute",
  inset: 0,
  backgroundImage: "url('/liveevent.jpg')",
  backgroundSize: "cover",
  backgroundPosition: "center 40%",
  zIndex: 0,
};

/* Heavy maroon gradient — replicates the rich dark-red look from the screenshot */
const heroOverlayStyle = {
  position: "absolute",
  inset: 0,
  background:
    "linear-gradient(135deg, rgba(50,0,0,0.88) 0%, rgba(128,0,0,0.82) 50%, rgba(60,0,0,0.92) 100%)",
  zIndex: 1,
};

/* Gold dashed top strip — matches the original .liveevent-hero::after */
const heroTopBorderStyle = {
  position: "absolute",
  top: 0, left: 0, right: 0,
  height: "6px",
  background:
    "repeating-linear-gradient(90deg, #c9a676 0px, #c9a676 30px, transparent 30px, transparent 50px)",
  zIndex: 3,
};

/* Content wrapper — above overlay, centered, keeps original padding */
const heroContentStyle = {
  position: "relative",
  zIndex: 2,
  textAlign: "center",
  padding: "80px 20px 70px",
  width: "100%",
};

const heroH2Style = {
  fontFamily: "'Playfair Display', serif",
  fontSize: "clamp(32px, 5vw, 56px)",
  fontWeight: 700,
  color: "white",
  marginBottom: "16px",
  lineHeight: 1.1,
};

const heroParaStyle = {
  color: "rgba(255,255,255,0.82)",
  fontSize: "16px",
  maxWidth: "540px",
  margin: "0 auto",
  lineHeight: 1.7,
};

/* ─── Card badge + archive label + latest-updates box styles ─── */
const latestBoxStyle = {
  background: "white",
  border: "1px solid #e8e0d4",
  borderLeft: "5px solid #800000",
  borderRadius: 12,
  padding: "20px 22px 24px",
  marginBottom: 36,
  boxShadow: "0 4px 18px rgba(128,0,0,0.07)",
};

const newBadgeStyle = {
  position: "absolute",
  top: 8,
  left: 8,
  background: "#e11d48",
  color: "white",
  fontSize: 10,
  fontWeight: 800,
  letterSpacing: 1,
  padding: "3px 9px",
  borderRadius: 20,
  zIndex: 3,
};

const archiveLabelStyle = {
  fontSize: 13,
  fontWeight: 800,
  letterSpacing: 1.5,
  textTransform: "uppercase",
  color: "#800000",
  marginBottom: 20,
};
